import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

declare var bootstrap: any;

@Directive({
  selector: '[appTooltip]',
  standalone: false
})
export class BootstrapTooltipDirective implements AfterViewInit, OnDestroy {
  private tooltipInstance: any;
  private observer: MutationObserver | null = null;
  private refreshPending = false;

  constructor(private elRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.initTooltipDeferred();
    this.observeTitleChanges();
  }

  ngOnDestroy(): void {
    this.disposeTooltip();
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  private initTooltipDeferred() {
    setTimeout(() => {
      this.initTooltip();
    });
  }

  private initTooltip() {
    const el = this.elRef.nativeElement as HTMLElement;
    if (!this.hasTooltipTitle(el)) {
      return;
    }
    this.disposeTooltip();
    this.tooltipInstance = new bootstrap.Tooltip(el);
  }

  private disposeTooltip() {
    if (this.tooltipInstance) {
      this.tooltipInstance.dispose();
      this.tooltipInstance = null;
    }
  }

  private hasTooltipTitle(el: HTMLElement): boolean {
    return Boolean(el.getAttribute('title') || el.getAttribute('data-bs-title'));
  }

  private observeTitleChanges() {
    const el = this.elRef.nativeElement as HTMLElement;
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          (mutation.attributeName === 'title' ||
            mutation.attributeName === 'data-bs-title' ||
            mutation.attributeName === 'data-bs-original-title')
        ) {
          this.requestRefresh();
          break;
        }
      }
    });
    this.observer.observe(el, { attributes: true });
  }

  private requestRefresh() {
    if (this.refreshPending) {
      return;
    }
    this.refreshPending = true;
    setTimeout(() => {
      this.refreshPending = false;
      this.initTooltip();
    });
  }
}
